import React from "react";
import Logo from "./Logo";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <div className="footer-logo">
          <Logo />
        </div>
        <p>© 2025 Restrix. All rights reserved.</p>
      </div>
      <ul className="footer-right">
        <Link to="/">
          <li>Home</li>
        </Link>
        <Link to="/privacyPolicy">
          <li>Privacy Policy</li>
        </Link>
      </ul>
    </footer>
  );
};

export default Footer;
